var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.438 1.707H14.25v-.56c0-.308-.266-.558-.594-.558-.328 0-.594.25-.594.559v.559H5.939v-.56c0-.308-.266-.558-.594-.558-.328 0-.594.25-.594.559v.559H3.562C1.595 1.707 0 3.207 0 5.06v11.176c0 1.852 1.595 3.353 3.563 3.353h11.874c1.968 0 3.563-1.501 3.563-3.353V5.06c0-1.852-1.595-3.353-3.563-3.353zm2.374 14.53c-.001 1.233-1.063 2.233-2.375 2.234H3.563c-1.312-.001-2.374-1.001-2.376-2.235V7.295h16.625v8.941zm0-10.06H1.188V5.06c.002-1.234 1.064-2.234 2.375-2.236H4.75v.56c0 .308.266.558.594.558.328 0 .593-.25.593-.559v-.559h7.125v.56c0 .308.266.558.594.558.328 0 .594-.25.594-.559v-.559h1.188c1.31.002 2.373 1.002 2.374 2.236v1.117zm-2.375 6.706c0 1.235-1.063 2.235-2.374 2.235-1.312 0-2.376-1-2.376-2.235 0-1.234 1.064-2.235 2.376-2.235 1.311 0 2.374 1 2.374 2.235z","fill":"#F0626D"}));
}

Calendar.defaultProps = {"width":"19","height":"20"};

module.exports = Calendar;

Calendar.default = Calendar;
